;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('AddTextController', AddTextController)

  AddTextController.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'InvoiceLineManager', 'CreditNoteLineManager',

    // Resolve
    'invoice', 'type', 'line'
  ]

  function AddTextController (
    // Angular
    $uibModalInstance,
    // Managers
    InvoiceLineManager,
    CreditNoteLineManager,
    // Resolve
    invoice, type, line
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes

        // Methods
        cancel: cancel,
        saveLine: saveLine
      })

      init()
    }

    function init () {
      if (!line) {
        self.modalTitle = 'Ajouter du texte'
      } else {
        self.modalTitle = 'Modifier le texte'
        self.title = line.title
        self.description = line.label
      }
      self.invoice = invoice
      self.type = type
    }

    function saveLine () {
      switch (self.type) {
        case 'invoice':
        case 'quote':
          var line = InvoiceLineManager.create({
            type: 'label',
            title: self.title,
            label: self.description,
            rubric: _.get(self, 'rubric.rubric._id', undefined),
            options: {
              type: 'text'
            }
          })
          $uibModalInstance.close(line)
          break
        case 'creditNote':
          var line = CreditNoteLineManager.create({
            type: 'label',
            title: self.title,
            label: self.description,
            rubric: _.get(self, 'rubric.rubric._id', undefined),
            options: {
              type: 'text'
            }
          })
          $uibModalInstance.close(line)
          break
        default:
      }
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
